<mat-sidenav-container class="sidenav-container">
  <mat-sidenav [disableClose]="true"
               [fixedTopGap]="64"
               [mode]="'side'"
               [ngClass]="{'sidenav--collapsed': isSidenavCollapsed}"
               [opened]="true"
               class="sidenav">
    <div class="sidenav__actions">
      <span (click)="toggle()" class="collapse-button">
        <mat-icon>{{isSidenavCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left'}}</mat-icon>
      </span>
    </div>
    <coa-sidenav
      [clientId]="clientId"
      [dateRange]="dateRange"
      [showLabels]="!isSidenavCollapsed"
      class="sidenav__list">
    </coa-sidenav>
  </mat-sidenav>

  <mat-sidenav-content
    [style.margin-left.px]="isSidenavCollapsed ? 56 : 156"
    class="sidenav__mat-sidenav-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<coa-compare-footer
  [clientId]="clientId"
  [dateRange]="dateRange"
  [selectableFeature]="selectableFeature"
  [selectableType]="selectableType"
  [selections]="selections"
  [sidenavCollapsed]="isSidenavCollapsed">
</coa-compare-footer>

<coa-create-group-footer
  [clientId]="clientId"
  [dateRange]="dateRange"
  [selectableFeature]="selectableFeature"
  [selectableType]="selectableType"
  [selections]="selections"
  [sidenavCollapsed]="isSidenavCollapsed">
</coa-create-group-footer>
